<template>
  <div class="cs-search" :class="{searchbar: isSearch}">
    <div class="h-full cs-form">
      <slot name="left-item"></slot>
      <input
        class=""
        type="text"
        v-model="lkeyword"
        @keypress.enter.stop="onSearch"
        placeholder="검색어를 입력해주세요."
      />
      <button
        v-if="isSearch"
        class="p-1 ml-1 text-lg cs-btn cs-btn-clear btn-search"
        @click="onCancel"
      >
        <i class="flex text-sm text-gray-300 fi fi-br-cross"></i>
      </button>
      <button v-else class="p-1 ml-1 text-lg cs-btn cs-btn-clear btn-search" @click="onSearch">
        <i class="flex text-gray-300 fi fi-br-search"></i>
      </button>
    </div>
  </div>
</template>

<script setup>
import {watch, ref} from "vue";
import {toast} from "vue3-toastify";

const emit = defineEmits(["onSearch", "onCancel"]);

let isSearch = ref(false);
let lkeyword = ref("");

const kw = ref("");

watch(kw, (newKeyworkd) => {
  lkeyword.value = "" + newKeyworkd;
});

const onSearch = () => {
  if (2 <= lkeyword.value.length) {
    isSearch.value = true;
    emit("onSearch", lkeyword.value);
  } else if (1 === lkeyword.value.length) {
    toast.warn("2자 이상 입력해주세요.", {
      transition: toast.TRANSITIONS.SLIDE,
      position: toast.POSITION.TOP_CENTER,
    });
  } else {
    onCancel();
  }
};

const onCancel = () => {
  lkeyword.value = "";
  isSearch.value = false;
  emit("onCancel", null);
};
</script>

<style lang="scss" scoped>
.cs-search {
  display: flex;
  position: relative;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  transition: border-color 0.2s;

  .cs-form {
    display: flex;
    align-items: center;
    width: 100%;
    // height: 100%;
  }

  .btn-search {
    position: absolute;
    top: 50%;
    right: 0.5rem;
    transform: translateY(-50%);
  }
}
</style>
